import type { Component, ParentProps } from 'solid-js'
import AsesorWidget from '~/layers/AsesorWidget'
import Footer from '~/layers/Footer'
import Navbar from '~/layers/Navbar'

const Layout: Component<ParentProps> = props => {
  return (
    <div class="min-h-screen grid grid-rows-[68px_1fr_auto]">
      <Navbar />
      <main class="flex-grow">{props.children}</main>
      <Footer />
      {/* Se oculta solo si la empresa no tiene asesor configurado. */}
      <AsesorWidget />
    </div>
  )
}

export default Layout
